<script setup>

</script>

<template>
  <NuxtLayout>
        <NuxtPage></NuxtPage>
      </NuxtLayout>
</template>
